export default __webpack_public_path__ + "images/favicon/8 КОНСУЛЬТАЦИИ_.jpg";